const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminManageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6843"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6148",
    d: "M141.839-880.675a1.772 1.772 0 0 1-1.3-.539 1.772 1.772 0 0 1-.539-1.3v-13.614a1.772 1.772 0 0 1 .539-1.3 1.772 1.772 0 0 1 1.3-.539h4.526a2.249 2.249 0 0 1 .739-1.44 2.193 2.193 0 0 1 1.541-.594 2.207 2.207 0 0 1 1.551.594 2.206 2.206 0 0 1 .73 1.44h4.526a1.772 1.772 0 0 1 1.3.539 1.772 1.772 0 0 1 .539 1.3v13.614a1.772 1.772 0 0 1-.539 1.3 1.772 1.772 0 0 1-1.3.539zm0-1.526h13.614a.3.3 0 0 0 .215-.1.3.3 0 0 0 .1-.215v-13.614a.3.3 0 0 0-.1-.215.3.3 0 0 0-.215-.1h-13.614a.3.3 0 0 0-.215.1.3.3 0 0 0-.1.215v13.614a.3.3 0 0 0 .1.215.3.3 0 0 0 .215.101zm1.975-2.406h6.611v-1.525h-6.611zm0-3.951h9.663v-1.526h-9.663zm0-3.951h9.663v-1.525h-9.663zm4.831-4.6a.741.741 0 0 0 .547-.216.741.741 0 0 0 .216-.547.741.741 0 0 0-.216-.547.741.741 0 0 0-.547-.216.741.741 0 0 0-.547.216.741.741 0 0 0-.216.547.741.741 0 0 0 .216.547.741.741 0 0 0 .548.225zm-7.12 14.9z",
    transform: "translate(-136.994 901.622)",
    style: {
      fill: "#030814"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157570",
    style: {
      fill: "none"
    },
    d: "M0 0h24v25H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminManageIcon);
export default __webpack_public_path__ + "static/media/admin_manage_icon.6373387c2f2a81ae971f2a6873bb09ee.svg";
export { ForwardRef as ReactComponent };